import React from "react";
import { HorizontalSeparator } from "@src/components/atoms/horizontal-separator/horizontal-separator";
import styles from "./ota-download-modal.module.scss";
import { useI18N } from "@src/language/language-context";
import DownloadIcon from "@src/assets/svg/download-icon.svg";
import BellIcon from "@src/assets/svg/bell-icon.svg";
import { Button } from "@src/components/atoms/buttons/button/button";

interface OtaDownloadModalProps {
  onClose: () => void;
}

const cssClassName = "ota-download-modal";

const OtaDownloadModal = ({ onClose }: OtaDownloadModalProps) => {
  const i18n = useI18N();

  const texts = {
    modalTitle: i18n("modules.otaDownloadModal.modalTitle"),
    backgroundTitle: i18n("modules.otaDownloadModal.backgroundTitle"),
    backgroundDescription: i18n(
      "modules.otaDownloadModal.backgroundDescription",
    ),
    zipInfoText: i18n("modules.otaDownloadModal.zipInfoText"),
    notificationText: i18n("modules.otaDownloadModal.notificationText"),
    closeButtonText: i18n("modules.otaDownloadModal.closeButtonText"),
  };

  return (
    <div className={styles[cssClassName]}>
      <div className={styles[`${cssClassName}__overlay`]} />
      <div className={styles[`${cssClassName}__dialog-wrapper`]}>
        <div
          className={styles[`${cssClassName}__modal-body`]}
          role="dialog"
          aria-modal="true"
        >
          <div className={styles[`${cssClassName}__header`]}>
            <img
              src={DownloadIcon}
              alt=""
              aria-hidden="true"
              className={styles[`${cssClassName}__header-icon`]}
            />
            <h2 className={styles[`${cssClassName}__header-title`]}>
              {texts.modalTitle}
            </h2>
          </div>

          <HorizontalSeparator verticalMargin={16} />

          <div className={styles[`${cssClassName}__content`]}>
            <h3 className={styles[`${cssClassName}__section-title`]}>
              {texts.backgroundTitle}
            </h3>

            <p className={styles[`${cssClassName}__description`]}>
              {texts.backgroundDescription}
            </p>

            <p className={styles[`${cssClassName}__description`]}>
              {texts.zipInfoText}
            </p>

            <div className={styles[`${cssClassName}__notification`]}>
              <img
                src={BellIcon}
                alt=""
                aria-hidden="true"
                className={styles[`${cssClassName}__notification-icon`]}
              />
              <p className={styles[`${cssClassName}__notification-text`]}>
                {texts.notificationText}
              </p>
            </div>

            <div className={styles[`${cssClassName}__footer`]}>
              <Button fun={onClose} text={texts.closeButtonText} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OtaDownloadModal;
